import type { auth as en } from '@/i18n/locales/en/auth';
import type { Translation } from '@/i18n/types';

export const auth: Translation<typeof en> = {
  signInFailed: 'Oturum açma başarısız oldu',
  checkingSession: 'Oturumunuz kontrol ediliyor…',
  redirectingToSignIn: 'Oturum açma sayfasına yönlendiriliyorsunuz…',
  signingIn: 'Oturum açılıyor…',
  backToDashboard: 'Panele geri dön',
};
